import { TagColor } from "@bridgesplit/ui";

import { TimeLockStatus, TimeLockUpdateType } from "../types";

export const DEFAULT_LP_SLIPPAGE = 0.001;

export const TIMELOCK_UPDATE_UI: Record<TimeLockUpdateType, string> = {
    [TimeLockUpdateType.UpdateStrategyMarketInformation]: "Update Strategy Market Information",
    [TimeLockUpdateType.AddCollateral]: "Add Collateral",
    [TimeLockUpdateType.UpdateLtv]: "Update LTV",
    [TimeLockUpdateType.RemoveCollateral]: "Remove Collateral",
    [TimeLockUpdateType.UpdateApy]: "Update APY",
    [TimeLockUpdateType.UpdateStrategySettings]: "Update Strategy Settings",
    [TimeLockUpdateType.UpdateVaultSettings]: "Update Vault Settings",
    [TimeLockUpdateType.CapsUpdate]: "Caps Update",
    [TimeLockUpdateType.UpdateCollateralAllocationPct]: "Update Collateral Allocation Percent"
};

export const TIMELOCK_STATUS_UI: Record<TimeLockStatus, string> = {
    [TimeLockStatus.Pending]: "Pending",
    [TimeLockStatus.Executed]: "Executed",
    [TimeLockStatus.Cancelled]: "Cancelled"
};

export const TIMELOCK_STATUS_COLOR: Record<TimeLockStatus, TagColor> = {
    [TimeLockStatus.Pending]: "warning",
    [TimeLockStatus.Executed]: "success",
    [TimeLockStatus.Cancelled]: "error"
};
